import { Trans } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';

export const OptionalLabel = () => (
  <InlineText size="200" color="disabled">
    {' '}
    <Trans id="design-system.label.optional">(optional)</Trans>
  </InlineText>
);
